import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import AppTemplate from '@/app/shared/ui/templates/AppTemplate.vue';
import InputProjects from '@/app/shared/components/inputs/InputProjects.vue';
import { computed, ref, reactive, inject, onMounted } from 'vue';
import rules from '@/app/shared/domain/data/rules';
import ServiceOrderRepository from '@/app/service-order/infrastructure/persistence/ServiceOrderRepository';
import ServiceOrder from '@/app/service-order/domain/interfaces/ServiceOrder';
import Tabs from '@/app/shared/components/Tabs.vue';
import { useForm } from '@/app/shared/ui/composable/form';
import StatusMapper from '@/app/shared/application/StatusMapper';
import useNotificationRepository from '@/app/shared/infrastructure/persistence/notification-repository';
import InputCollaborator from '@/app/shared/components/inputs/InputCollaborator.vue';
import useRoleRepository from '@/app/shared/infrastructure/persistence/role-repository';
import { RolesEnum } from '@/app/shared/domain/RolesEnum';
import useUserRepository from '@/app/shared/infrastructure/persistence/user-repository';


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceOrderForm',
  props: ['id'],
  setup(__props) {

const props = __props;

const userRepository = useUserRepository();
const user = userRepository.get();
const roleRepository = useRoleRepository();
const notificationRepository = useNotificationRepository();
const form = ref(null);

const repository = inject('serviceOrderRepository') as ServiceOrderRepository;

let serviceOrder = reactive({
    status: 'open',
    has_transport: false,
} as ServiceOrder);

const { pageTitle, submit, isEditPage } = useForm(
    props,
    serviceOrder,
    repository,
    form,
    'Editar ordem de serviço',
    'Cadastrar ordem de serviço',
    '/ordens-de-servico',
    '/ordens-de-servico',
);

const handleClose = async () => {
    await repository.close(serviceOrder.id);

    serviceOrder.status = 'closed';

    notificationRepository.insert({
        id: Date.now().toString(),
        type: 'success',
        message: 'Ordem de serviço fechada com sucesso',
    });
};

const canClose = computed(() => {
    return isEditPage.value ? serviceOrder.status === 'open' : false;
});

const collaboratorIdReadonly = computed(() => {
    if (isEditPage.value === true) {
        return !roleRepository.has(RolesEnum.UPDATE_SERVICE_ORDER_ADMIN);
    }
    return !roleRepository.has(RolesEnum.CREATE_SERVICE_ORDER_ADMIN);
});

onMounted(() => {
    if (
        collaboratorIdReadonly.value === true
        && isEditPage.value === false
    ) {
        serviceOrder.collaborator_id = user.id;
    }
});

const tabItens = [
    {
        icon: 'mdi:mdi-book-open',
        key: 'main',
        title: 'Principal'
    },
];

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createBlock(AppTemplate, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { justify: "space-around" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { width: "100%" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar, { color: "surface" }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: _unref(submit),
                    "prepend-icon": "mdi:mdi-content-save",
                    color: "primary",
                    variant: "flat"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Salvar")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_toolbar_title, { class: "text-h6" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(pageTitle)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_form, {
                    "lazy-validation": "",
                    ref_key: "form",
                    ref: form
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Tabs, { itens: tabItens }, {
                        main: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createVNode(_component_v_text_field, {
                                            label: "Data",
                                            rules: [_unref(rules).date, _unref(rules).required],
                                            modelValue: _unref(serviceOrder).date,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(serviceOrder).date) = $event))
                                          }, null, 8, ["rules", "modelValue"]), [
                                            [_directive_mask, '##/##/####']
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        md: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputProjects, {
                                            rules: [_unref(rules).required],
                                            modelValue: _unref(serviceOrder).project_id,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(serviceOrder).project_id) = $event))
                                          }, null, 8, ["rules", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        md: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createVNode(_component_v_text_field, {
                                            rules: [_unref(rules).required, _unref(rules).hour],
                                            label: "Inicio",
                                            modelValue: _unref(serviceOrder).start_hour,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(serviceOrder).start_hour) = $event))
                                          }, null, 8, ["rules", "modelValue"]), [
                                            [_directive_mask, '##:##']
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        md: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createVNode(_component_v_text_field, {
                                            rules: [_unref(rules).hour],
                                            label: "Fim",
                                            modelValue: _unref(serviceOrder).end_hour,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(serviceOrder).end_hour) = $event))
                                          }, null, 8, ["rules", "modelValue"]), [
                                            [_directive_mask, '##:##']
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        md: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createVNode(_component_v_text_field, {
                                            label: "Horas à descontar",
                                            rules: [_unref(rules).hour],
                                            modelValue: _unref(serviceOrder).hours_to_discount,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(serviceOrder).hours_to_discount) = $event))
                                          }, null, 8, ["rules", "modelValue"]), [
                                            [_directive_mask, '##:##']
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_switch, {
                                            modelValue: _unref(serviceOrder).has_transport,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(serviceOrder).has_transport) = $event)),
                                            inset: "",
                                            color: "primary",
                                            label: "Translado?"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      (_unref(serviceOrder).has_transport)
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 0,
                                            cols: "12",
                                            md: "6"
                                          }, {
                                            default: _withCtx(() => [
                                              _withDirectives(_createVNode(_component_v_text_field, {
                                                rules: [_unref(rules).required, _unref(rules).hour],
                                                label: "Horas de translado",
                                                modelValue: _unref(serviceOrder).hour_transport,
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(serviceOrder).hour_transport) = $event))
                                              }, null, 8, ["rules", "modelValue"]), [
                                                [_directive_mask, '##:##']
                                              ])
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            label: "Título",
                                            rules: [_unref(rules).required],
                                            modelValue: _unref(serviceOrder).title,
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(serviceOrder).title) = $event))
                                          }, null, 8, ["rules", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            rules: [_unref(rules).email],
                                            label: "E-mail adicional",
                                            modelValue: _unref(serviceOrder).email_add,
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(serviceOrder).email_add) = $event))
                                          }, null, 8, ["rules", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputCollaborator, {
                                            readonly: _unref(collaboratorIdReadonly),
                                            rules: [_unref(rules).required],
                                            modelValue: _unref(serviceOrder).collaborator_id,
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(serviceOrder).collaborator_id) = $event))
                                          }, null, 8, ["readonly", "rules", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      (_unref(isEditPage))
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 1,
                                            cols: "12",
                                            sm: "6"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_text_field, {
                                                label: "Status",
                                                readonly: "",
                                                "model-value": _unref(StatusMapper).map(_unref(serviceOrder).status)
                                              }, null, 8, ["model-value"])
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_textarea, {
                                            label: "Descrição",
                                            rules: [_unref(rules).required],
                                            modelValue: _unref(serviceOrder).description,
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(serviceOrder).description) = $event))
                                          }, null, 8, ["rules", "modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (_unref(isEditPage))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createVNode(_component_v_divider, { class: "my-10" }),
                                        (_unref(canClose))
                                          ? (_openBlock(), _createBlock(_component_v_row, {
                                              key: 0,
                                              class: "justify-center justify-sm-end"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, {
                                                  cols: "6",
                                                  sm: "3",
                                                  class: "justify-center d-flex"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_btn, {
                                                      onClick: handleClose,
                                                      "prepend-icon": "fa-solid fa-check",
                                                      color: "primary"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("Fechar")
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})